const findInEntity = (entity, value, idField, findField) => {
  if (entity && entity.length) {
    const findObj = entity.find(e => e[idField] === value);
    return findObj && findObj[findField] ? findObj[findField] : '';
  }
  return '';
};

export { findInEntity };
